module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/thumb.38bd1140.jpg";